import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/phone-central'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'phone_central_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'phone_central_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'phone_central_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
